import React, { useEffect, useRef, useState } from 'react'
import { createMarkupWithOption } from '../../models/Common'
import { IQuizQuestion } from '../../models/WorkplaceQuiz'
import Conditional from '../common/Conditional'

export interface IWorkplaceQuizModuleQuestionFeedbackProps {
  question: IQuizQuestion
  answeredCorrect: boolean
  maybeAnsweredCorrect: boolean
  retryAnswer: boolean
  almostCorrect: boolean
}

const WorkplaceQuizModuleQuestionFeedback = (
  props: IWorkplaceQuizModuleQuestionFeedbackProps
) => {
  const mountedRef = useRef(false)
  const [isLoading, setIsLoading] = useState(true)
  const [, setQuestion] = useState<IQuizQuestion>()
  const [content, setContent] = useState<string>()
  const [cssClass, setCssClass] = useState<string>()

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current) {
      setQuestion(props.question)
      if (props.maybeAnsweredCorrect) {
        setContent(props.question.maybeFeedbackContent)
        setCssClass('feedbackText maybe')
      } else if (props.almostCorrect) {
        setContent(props.question.maybeFeedbackContent)
        setCssClass('feedbackText maybe')
      } else if (props.answeredCorrect) {
        setContent(props.question.correctFeedbackContent)
        setCssClass('feedbackText correct')
      } else if (props.retryAnswer) {
        setContent(props.question.retryFeedbackContent)
        setCssClass('feedbackText maybe')
      } else {
        setContent(props.question.failureFeedbackContent)
        setCssClass('feedbackText incorrect')
      }

      setIsLoading(false)
    }
    return () => {
      mountedRef.current = false
    }
  }, [props.question])

  return (
    <Conditional if={!isLoading}>
      <div
        id="feedh"
        className={cssClass}
        dangerouslySetInnerHTML={createMarkupWithOption(content, {
          ADD_ATTR: ['target'],
        })}
      ></div>
    </Conditional>
  )
}

export default WorkplaceQuizModuleQuestionFeedback
